import {createContext, forwardRef} from "react";
import {
    DefaultPhoneUserHomepageColorThemeContextValue,
    DefaultUserHomepageControllerContextValue,
    DefaultUserHomepageProductContextValue,
    DefaultUserHomepageStateContextValue,
    DefaultUserHomepageViewContextValue
} from "./models";
import _UserHomepageStateController from './ui/contexts/state-controller';
import _UserHomepageView from './ui/contexts/view';

export const UserHomepageStateController = forwardRef(_UserHomepageStateController);
export const UserHomepageView = forwardRef(_UserHomepageView);

export const UserHomepageStateContext = createContext(DefaultUserHomepageStateContextValue);
export const UserHomepageControllerContext = createContext(DefaultUserHomepageControllerContextValue);

export const UserHomepageColorThemeContext = createContext(DefaultPhoneUserHomepageColorThemeContextValue);

export const UserHomepageProductContext = createContext(DefaultUserHomepageProductContextValue);
export const UserHomepageViewContext = createContext(DefaultUserHomepageViewContextValue);
